// Lookup only. All distances/loads are calculated by the canonical backend services.
const input = (value, fallback = 'missing') => value === '' || value == null || !Number.isFinite(Number(value)) ? fallback : String(Number(value));
export const prescriptionSuggestionKey = (block, exercise) => {
  if (block.block_type === 'STRENGTH') return `${exercise.exercise_id}_${block.training_objective}`;
  if (block.block_type === 'AEROBIC') return `aerobic_${exercise.exercise_id}_${input(exercise.work_sec)}_${input(exercise.intensity_pct)}_${input(exercise.sets, '1')}_${input(exercise.reps, '1')}`;
  return null;
};

export const getPrescriptionSuggestions = (data, block, exercise) => {
  const exact = data?.[prescriptionSuggestionKey(block, exercise)];
  if (Array.isArray(exact)) return exact;
  if (block.block_type !== 'AEROBIC') return [];
  // Legacy snapshots used work+intensity but omitted sets/reps. Never prefix-match.
  const legacy = data?.[`aerobic_${exercise.exercise_id}_${input(exercise.work_sec)}_${input(exercise.intensity_pct)}`];
  if (!Array.isArray(legacy)) return [];
  return legacy.filter(row => input(row.sets, '1') === input(exercise.sets, '1') && input(row.reps, '1') === input(exercise.reps, '1'));
};